import {VideoItemContainerDefaultBox} from "./video-item-container-default.box";

export const VideoItemContainerBox = VideoItemContainerDefaultBox;
